export default __webpack_public_path__ + "static/media/icon-tables.8efde9ad.svg";